export const STATUS_PILL_PALETTES = {
  gray: { color: '#344054', background: '#F9FAFB', border: '#E4E7EC' },
  warning: { color: '#B54708', background: '#FFFAEB', border: '#FEDF89' },
  brand: { color: '#B83F0E', background: '#FCEFE9', border: '#F1BFA8' },
  success: { color: '#067647', background: '#ECFDF3', border: '#ABEFC6' },
  error: { color: '#B42318', background: '#FEF3F2', border: '#FECDCA' },
  purple: { color: '#5925DC', background: '#F4F3FF', border: '#D9D6FE' },
  blueLight: { color: '#026AA2', background: '#F0F9FF', border: '#B9E6FE' },
  blue: { color: '#175CD3', background: '#EFF8FF', border: '#B2DDFF' }
} as const;

export const STATUS_PILL_VARIANT_MAP: Record<string, keyof typeof STATUS_PILL_PALETTES> = {
  not_assigned: 'gray', // Gray
  awaiting_first_contact: 'gray',
  contact_attempted: 'gray',
  awaiting_qualification: 'gray',
  partially_qualified: 'gray',
  not_qualified: 'gray',
  opted_out: 'gray',
  not_submitted: 'gray',
  deleted: 'gray',

  in_progress: 'warning', // Warning
  qualified: 'warning',
  prepared: 'warning',
  warming_up: 'warning',
  underwriting: 'warning',
  exchanged: 'warning',

  submitted: 'brand', // Brand
  offered: 'brand',
  mortgage_offer_issued: 'brand',
  received_by_lender: 'brand',
  valuation_instructed: 'brand',
  valuation_received: 'brand',
  valuation_booked: 'brand',
  approved: 'brand',

  completed: 'success', // Success
  replacement_in_progress: 'success',
  replaced: 'success',
  keeping_warm: 'success',
  accepted: 'success',
  accepted_non_standard: 'success',
  on_risk: 'success',

  not_proceeding: 'error',
  engaged: 'error',
  declined: 'error',
  referred: 'error',
  missed: 'error',

  // Not proceeding
  another_broker: 'purple',
  property_sold: 'warning',
  dont_contact: 'blueLight',
  went_direct: 'error',
  mortgage_paid: 'blue',
  cancelled: 'warning',
  no_response: 'gray',
  never_responded: 'gray',
  stopped_responding: 'gray',
  duplicate: 'gray',
  wrong_ped: 'warning',
  compliance_risk: 'error',
  must_do_direct: 'blue',
  other: 'gray'
};

export const PILL_COLORS = {
  whatsapp: '#17B26A',
  email: '#667085',
  phone: '#6172F3',
  document: '#EE46BC',
  factfind: '#D65423'
} as const;

export const COMMON_BORDER_STYLES = {
  'border-width': '1px',
  'border-style': 'solid'
} as const;
